import React from 'react';
import { Navigate } from 'react-router-dom';
import authService, { isInPopup } from '../../services/authService';

const LoginCallback = () => {
  const [done, setDone] = React.useState(false);
  // Captured once so the render path cannot change between mount and effect.
  const [inPopup] = React.useState(isInPopup);

  React.useEffect(() => {
    if (inPopup) {
      // Popup flow: hand the tokens to the opener and close. Deliberately does
      // not redirect — handleLoginCallback forces a navigation to '/', which
      // would leave the popup sitting on the app instead of closing.
      authService.completePopupLogin();
      return;
    }

    authService.handleLoginCallback(window.location.href).then(() => {
      setDone(true);
    });
  }, [inPopup]);

  if (inPopup || !done) {
    return null;
  }
  return <Navigate to="/" />;
};

export default LoginCallback;
